import getServiceStatus from './getServiceStatus'

export default [getServiceStatus]
